'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalPharmacy = function MdLocalPharmacy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 23.4v-3.4h-5v-5h-3.2v5h-5v3.4h5v5h3.2v-5h5z m8.4-15v3.2l-3.4 10 3.4 10v3.4h-30v-3.4l3.4-10-3.4-10v-3.2h21.2l2.4-6.8 3.9 1.5-1.9 5.3h4.4z' })
        )
    );
};

exports.default = MdLocalPharmacy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-pharmacy.js
// module id = 1698
// module chunks = 168707334958949